module.exports = __webpack_public_path__ + "img/afesnew.a1e02312.png";